import { render, staticRenderFns } from "./PuntoVentaSettingCombobox.vue?vue&type=template&id=c4c95e38&scoped=true&"
import script from "./PuntoVentaSettingCombobox.vue?vue&type=script&lang=js&"
export * from "./PuntoVentaSettingCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c95e38",
  null
  
)

export default component.exports